import React from 'react'
import createReactClass from 'create-react-class'
import ReportPanelContainer from '../containers/report-panel-container'

export default createReactClass({
  render () {
    return (
      <section>
        <ReportPanelContainer {...this.props}/>
      </section>
    )
  },
})



// WEBPACK FOOTER //
// ./src/views/report.js